module.exports = __webpack_public_path__ + "static/media/Patricia_Travessa.2f142051.jpeg";